import { singleton, inject } from "tsyringe";

import type { HttpAdapter } from "@/shared/libs/http/interface";

import type { StudentGroupRepository } from "@/entities/student-group/domain/repository";
import type {
    GetStudentGroupsResponseDto,
    StudentGroupDto,
} from "@/entities/student-group/domain/dtos";

const DEFAULT_STUDENT_GROUPS_ORDERS = encodeURIComponent(JSON.stringify([{ name: 1 }]));
const STUDENT_GROUPS_PAGE_SIZE = 100;

@singleton()
export default class StudentGroupRepositoryImpl implements StudentGroupRepository {
    constructor(@inject("HttpAdapter") private readonly httpAdapter: HttpAdapter) {}

    getStudentGroups = async (academyId: string): Promise<StudentGroupDto[]> => {
        const allItems: StudentGroupDto[] = [];
        let nextToken: string | undefined;

        do {
            let url =
                `/v1/student-groups?academyId=${academyId}` +
                `&size=${STUDENT_GROUPS_PAGE_SIZE}` +
                `&orders=${DEFAULT_STUDENT_GROUPS_ORDERS}`;

            if (nextToken) {
                url += `&nextToken=${encodeURIComponent(nextToken)}`;
            }

            const response = await this.httpAdapter.get<GetStudentGroupsResponseDto>(url);
            allItems.push(...response.items);
            nextToken = response.nextToken;
        } while (nextToken);

        return allItems;
    };
}
